import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Toaster } from './components/ui/sonner';
import Login from './pages/Login';
import Register from './pages/Register';
import Layout from './pages/Layout';
import Dashboard from './pages/Dashboard';
import Incidents from './pages/Incidents';
import Investigations from './pages/Investigations';
import Tasks from './pages/Tasks';
import Evidence from './pages/Evidence';
import SafetyRecommendations from './pages/SafetyRecommendations';
import Correspondence from './pages/Correspondence';
import Reports from './pages/Reports';
import Inventory from './pages/Inventory';
import Automation from './pages/Automation';
import InvestigationDetail from './pages/InvestigationDetail';
import TaskDetail from './pages/TaskDetail';
import Synthesis from './pages/Synthesis';
import ReportGeneration from './pages/ReportGeneration';
import Fishbone from './pages/Fishbone';
import Timeline from './pages/Timeline';
import Settings from './pages/Settings';
import PartsManagement from './pages/PartsManagement';
import ARIdentify from './pages/ARIdentify';
import Help from './pages/Help';
import AdrepReporting from './pages/AdrepReporting';
import './App.css';

function App() {
  return (
    <ThemeProvider>
    <AuthProvider>
      <NotificationProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="incidents" element={<Incidents />} />
            <Route path="investigations" element={<Investigations />} />
            <Route path="investigations/:id" element={<InvestigationDetail />} />
            <Route path="investigations/:id/synthesis" element={<Synthesis />} />
            <Route path="investigations/:id/report" element={<ReportGeneration />} />
            <Route path="investigations/:id/fishbone" element={<Fishbone />} />
            <Route path="investigations/:id/timeline" element={<Timeline />} />
            <Route path="investigations/:id/adrep" element={<AdrepReporting />} />
            <Route path="tasks/:taskId" element={<TaskDetail />} />
            <Route path="tasks" element={<Tasks />} />
            <Route path="evidence" element={<Evidence />} />
            <Route path="safety-recommendations" element={<SafetyRecommendations />} />
            <Route path="correspondence" element={<Correspondence />} />
            <Route path="reports" element={<Reports />} />
            <Route path="inventory" element={<Inventory />} />
            <Route path="automation" element={<Automation />} />
            <Route path="ar-identify" element={<ARIdentify />} />
            <Route path="parts" element={<PartsManagement />} />
            <Route path="settings" element={<Settings />} />
            <Route path="help" element={<Help />} />
          </Route>
        </Routes>
      </BrowserRouter>
      </NotificationProvider>
      <Toaster />
    </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
